import { memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './ListCardRow.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  title?: ReactNode
}

export const ListCardRow = memo(function ListCardRow({ title, children, className }: IProps) {
  return children ? (
    <>
      {title && <div className={s.title}>{title}</div>}
      <div className={cn(className, s.content)}>{children}</div>
    </>
  ) : null
})
